// Flagship hero tabs: click a thumbnail to swap the active product panel.
// Optional autoplay (data-autoplay / data-interval): loops, pauses on hover or focus,
// stops for good once the visitor picks a tab, and never runs under prefers-reduced-motion.
// Full tablist keyboard support (ArrowLeft/ArrowRight/Home/End) plus prev/next scroll arrows
// for the overflowing tab row on desktop.
(function () {
  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-flagship-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-flagship-panel]'));
    if (!tabs.length) return;
    var tablist = root.querySelector('[data-flagship-tablist]');
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-flagship-scroll]'));

    function select(tab, moveFocus) {
      var id = tab.getAttribute('data-flagship-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-flagship-panel') !== id; });
      tabs.forEach(function (t) { var b = t.querySelector('.jrdg-flag__progress'); if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } });
      if (moveFocus) tab.focus();
    }

    var timer = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced && tabs.length > 1;
    var interval = Math.max(4, parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    function current() { return tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; }); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (!autoplay || timer) return; timer = setInterval(function () { select(tabs[(current() + 1) % tabs.length], false); }, interval); }
    function kill() { autoplay = false; stop(); root.classList.remove('jrdg-flag--auto'); }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { kill(); select(tab, false); });
    });
    var hoverZone = root.querySelector('[data-flagship-tabwrap]') || root;
    hoverZone.addEventListener('mouseenter', stop);
    hoverZone.addEventListener('mouseleave', start);
    hoverZone.addEventListener('focusin', stop);
    hoverZone.addEventListener('focusout', function () { if (!hoverZone.contains(document.activeElement)) start(); });
    root.classList.toggle('jrdg-flag--auto', autoplay);
    root.style.setProperty('--jrdg-flag-interval', (interval / 1000) + 's');
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var current = tabs.indexOf(document.activeElement);
        if (current === -1) return;
        var next = -1;
        if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === -1) return;
        e.preventDefault();
        select(tabs[next], true);
      });
    }

    function syncArrows() {
      if (!tablist) return;
      var overflowing = tablist.scrollWidth > tablist.clientWidth;
      arrows.forEach(function (a) { a.hidden = !overflowing; });
    }

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        if (!tablist) return;
        var step = tablist.clientWidth * 0.6;
        if (arrow.getAttribute('data-flagship-scroll') === 'prev') step = -step;
        tablist.scrollBy({ left: step, behavior: 'smooth' });
      });
    });

    syncArrows();
    window.addEventListener('resize', syncArrows);
    if (window.ResizeObserver && tablist) {
      new ResizeObserver(syncArrows).observe(tablist);
    }
  }
  document.querySelectorAll('[data-flagship]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-flagship]').forEach(init); });
})();
